// extracted by mini-css-extract-plugin
module.exports = {"coupon":"_1NraJ","textButton":"_30ckm","viewMode":"_1lxRu"};